import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Button, HiddenVisually, Image, Stack, Text, useTheme } from "@bookingcom/bui-react";
import styles from "./GeniusAirlinesBanner.module.css";
import { Trans, t, useI18n } from "@bookingcom/lingojs-react";
import useGeniusAirlinesBannerEvent from "../../../hooks/c360/useGeniusAirlinesBannerEvent.js";
import useCreateUrl from "../../../hooks/useCreateUrl.js";
import web_flights_lve_deal_landing_page from "../../../utils/experiments/lve/web_flights_lve_deal_landing_page.js";
import { getDealsEntryPointUrl } from "./dealsEntryPointUrl.js";
const GeniusAirlinesBannerMobile = (props) => {
    const { geniusAirlineBannerData, showDealsEntryPoint = false } = props;
    const airlines = geniusAirlineBannerData.airlines;
    const theme = useTheme();
    const i18n = useI18n();
    const { createUrlWithApiPrefix } = useCreateUrl();
    const { search } = useLocation();
    const dealsEntryPointUrl = getDealsEntryPointUrl(search);
    const trackGeniusAirlinesBannerEvent = useGeniusAirlinesBannerEvent();
    useEffect(() => {
        trackGeniusAirlinesBannerEvent(airlines.map((airline) => airline.iataCode));
    }, [trackGeniusAirlinesBannerEvent, airlines]);
    const renderCarrierList = () => {
        const firstThreeAirlines = airlines.slice(0, 3);
        const secondThreeAirlines = airlines.slice(3, 6);
        const renderCarrierItem = ({ name, imageUrl }) => !!name &&
            !!imageUrl && (React.createElement(Stack.Item, { key: name, className: styles.airlinesLogoWrapperAsPrimaryOffer, attributes: { role: "listitem" } },
            React.createElement(Stack, { direction: "column", justifyContent: "space-between", alignItems: "center", gap: 2 },
                React.createElement(Image, { width: "32px", src: imageUrl, "aria-hidden": "true", alt: "" }),
                React.createElement(Text, { variant: "small_2", wrap: "balance", maxLines: 1, bidirectional: true }, name))));
        return (React.createElement(Stack, { direction: "row", justifyContent: "space-between", attributes: { role: "list" } },
            firstThreeAirlines.map(renderCarrierItem),
            secondThreeAirlines.map(renderCarrierItem)));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, { direction: "column", gap: 3, className: styles.container, alignItems: "start", justifyContent: "space-between" },
            React.createElement(Stack.Item, { className: styles.bannerText },
                React.createElement(Text, { variant: "strong_1" },
                    React.createElement(HiddenVisually, { tagName: "h3" },
                        React.createElement(Trans, { "aria-hidden": true, tag: "flights_index_genius_airline_banner_title", variables: {
                                start_styling: "",
                                end_styling: ""
                            } })),
                    React.createElement("div", { "aria-hidden": true },
                        React.createElement(Trans, { tag: "flights_index_genius_airline_banner_title", variables: {
                                start_styling: "<0>",
                                end_styling: "</0>"
                            }, components: [React.createElement("span", { key: 0, style: { color: theme.colors.color_brand_primary_background } })] }))),
                React.createElement(Text, { variant: "body_2", className: styles.subtitle },
                    React.createElement(Trans, { tag: "flights_index_genius_airline_banner_body" }))),
            React.createElement(Stack.Item, { mixin: { width: "100%" } }, renderCarrierList()),
            showDealsEntryPoint ? (React.createElement(Button, { href: createUrlWithApiPrefix(dealsEntryPointUrl), text: i18n.trans(t("web_flights_deals_entry_point_airline_banner_link")), variant: "primary", onClick: () => web_flights_lve_deal_landing_page.goals.entry_clicked() })) : null),
        React.createElement(Text, { variant: "small_2", align: "start", className: styles.textBelowBanner, color: "neutral_alt" },
            React.createElement(Trans, { tag: "flights_lve_airline_promotions_genius_tooltip" }))));
};
export default GeniusAirlinesBannerMobile;
